import { useEffect, useRef } from 'react';
import Shepherd from 'shepherd.js';
import { getTutorial, initTutorialStore, updateTutorial } from './storage';
import './tutorial.scss';
import AnalyticsEvent from '../../services/analytics/AnalyticsEvent';

const addSteps = (steps, tour) => {
  // Return nothing if there are no steps
  if (!steps.length) {
    return [];
  }

  let customSteps = typeof steps === 'function' ? steps(tour) : steps;

  const parsedStepsforAction = customSteps.map(step => {
    const { buttons } = step;

    if (buttons) {
      step.buttons = buttons.map(button => {
        const { action, classes, disabled, label, secondary, text, type } =
          button;
        return {
          action: type ? tour[type] : action,
          classes,
          disabled,
          label,
          secondary,
          text,
          type,
        };
      });
    }

    return step;
  });

  return parsedStepsforAction.forEach(step => tour.addStep(step));
};

const defaultStepOptions = {
  defaultStepOptions: {
    scrollTo: true,
    cancelIcon: {
      enabled: true,
    },
  },
  scrollTo: { behavior: 'smooth', block: 'center' },
  useModalOverlay: true,
};

export const useTutorial = ({
  name = '',
  version = 1,
  options = {},
  steps = [],
}) => {
  const tourObject = useRef();
  const userDefaultOptions =
    options && options.defaultStepOptions ? options.defaultStepOptions : {};
  const defaultOptions = {
    ...defaultStepOptions,
    defaultStepOptions: {
      ...defaultStepOptions.defaultStepOptions,
      ...userDefaultOptions,
    },
    ...options,
  };

  useEffect(() => {
    if (tourObject.current) {
      return;
    }

    tourObject.current = new Shepherd.Tour(defaultOptions);
    tourObject.current.on('start', () => {
      AnalyticsEvent().tutorialViewed({ moduleName: name });
      const element = document.querySelector('.faq-helper');
      element.style.display = 'none';
    });

    addSteps(steps, tourObject.current);
    return () => {
      tourObject.current.off('start', () => {
        const element = document.querySelector('.faq-helper');
        element.style.display = 'none';
      });
      tourObject.current = null;
    };
  }, []);

  const initialize = () => {
    let cacheTutorial = getTutorial(name);

    if (Object.values(cacheTutorial).length <= 0) {
      cacheTutorial = initTutorialStore({ name });
    }

    if (!cacheTutorial.visited || cacheTutorial.version < version) {
      tourObject.current.start();

      updateTutorial({
        name: name,
        content: {
          number: Number(cacheTutorial.number) + 1,
          lastStep: cacheTutorial.lastStep,
          visited: true,
          version: version,
        },
      });
    }
  };

  return { tourInstance: tourObject.current, initTutorial: initialize };
};
